const hideElement = document.querySelector("#dynamic-form-hide");

function init() {
  try {
    const formIntersectionElement = document.querySelector(
      "#dynamic-form-intersection",
    );
    if (formIntersectionElement && hideElement) {
      const observer = new IntersectionObserver(formIntersectHandler, {
        rootMargin: "0px 0px -400px 0px",
      });
      observer.observe(formIntersectionElement);
    }
  } catch (_error) {
    // Do nothing
  }
}

function formIntersectHandler([form]) {
  if (form.isIntersecting) {
    hideElement.classList.add("invisible");
  } else {
    hideElement.classList.remove("invisible");
  }
}

init();
